// Helpers
import { transformDateToLocalDateString } from "helpers";

// Servisni sloj
import { VEHICLE_LOCATION_TYPE_CONFIG } from "services/api/fleet/vehicles/locations/consts";
import { VehicleTransferRow } from "services/api/fleet/vehicles/locations/search/types";
import { FleetVehicleStatusEnum } from "services/api/fleet/vehicles/types";

// UI
import Badge from "ui/components/Badge/Badge";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import VehicleCell from "ui/components/Table/TableSearch/components/Cells/VehicleCell";
import VehicleStatusBadge from "ui/modules/fleet/vehicles/pages/components/VehicleStatusEditCard/components/VehicleStatusBadge";

export const FLEET_TRANSFER_SEARCH_COLUMNS = (
  onVehicleClick: (event: React.MouseEvent, vehicleId: string) => void
): Column[] => [
  {
    title: "admin.fleet.vehicle.transfer.search.vehicle",
    key: "transfer_vehicle",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleTransferRow) => {
      if (!row.vehicle) return null;

      return (
        <VehicleCell
          vehicle={row.vehicle}
          onClick={(e) => onVehicleClick(e, row.vehicle!.id)}
        />
      );
    },
  },
  {
    title: "admin.fleet.vehicle.transfer.search.name",
    key: "transfer_name",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleTransferRow) => (
      <div className="text-md font-medium text-slate-900 truncate">
        {row.location?.name || "-"}
      </div>
    ),
  },
  {
    title: "admin.fleet.vehicle.transfer.search.type",
    key: "transfer_type",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleTransferRow) => {
      const config = row.location?.locationType
        ? VEHICLE_LOCATION_TYPE_CONFIG[row.location.locationType]
        : null;

      return (
        <span className="text-sm text-slate-600">{config?.label ?? "-"}</span>
      );
    },
  },
  {
    title: "admin.fleet.vehicle.transfer.search.location",
    key: "transfer_location",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleTransferRow) => (
      <div className="text-md font-medium text-slate-600 truncate">
        {row.location?.locationName ?? "-"}
      </div>
    ),
  },
  {
    title: "admin.fleet.vehicle.transfer.search.validfrom",
    key: "transfer_validfrom",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleTransferRow) => (
      <div className="text-sm text-slate-900">
        {row.location?.validFrom
          ? transformDateToLocalDateString(row.location.validFrom)
          : "-"}
      </div>
    ),
  },
  {
    title: "admin.fleet.vehicle.transfer.search.validuntil",
    key: "transfer_validuntil",
    field: "",
    type: ColumnTypes.custom,
    // Aktivna lokacija nema kraj — umjesto crtice se označi da je vozilo još uvijek ondje.
    render: (row: VehicleTransferRow) =>
      row.location?.isActive ? (
        <Badge text="Trenutno" variant="success" height="small" showDot />
      ) : (
        <div className="text-sm text-slate-900">
          {row.location?.validUntil
            ? transformDateToLocalDateString(row.location.validUntil)
            : "-"}
        </div>
      ),
  },
  {
    title: "admin.fleet.vehicle.transfer.search.driver",
    key: "transfer_driver",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleTransferRow) => (
      <div className="text-sm text-slate-900 truncate">
        {row.location?.driverName ?? "-"}
      </div>
    ),
  },
  {
    title: "admin.fleet.vehicle.transfer.search.status",
    key: "transfer_status",
    field: "",
    type: ColumnTypes.custom,
    // Popunjeno samo kad je premještaj došao uz promjenu statusa.
    render: (row: VehicleTransferRow) =>
      row.location?.vehicleStatus ? (
        <VehicleStatusBadge
          status={row.location.vehicleStatus as FleetVehicleStatusEnum}
          showDropdownIcon={false}
        />
      ) : (
        <div className="text-sm text-slate-400">-</div>
      ),
  },
  {
    title: "admin.fleet.vehicle.transfer.search.usercreated",
    key: "transfer_usercreated",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleTransferRow) => (
      <div className="text-sm text-slate-500 truncate">
        {row.location?.userCreatedName ?? "-"}
      </div>
    ),
  },
];
